import { formatPrice } from "./formatPrice";
/**
 * Formats a price in pennies to be in dollars with the currency symbol.
 */
export const formatPriceWithCurrencySymbol = (price, formattingOptions, symbol = "$") => price >= 0 ? `${symbol}${formatPrice(price, formattingOptions)}` : `–${symbol}${formatPrice(Math.abs(price), formattingOptions)}`;
//# sourceMappingURL=formatPriceWithCurrencySymbol.js.map